import { actions } from 'react-redux-form';

import { httpGet } from '../../../../utils/api.utils';
import {
    accessInformationFormModel,
    getCircuitAccessInformationDetails,
} from "../../../../constants/model-reducers/external/inventory/circuit-details/details-view/access-information.settings";

const defaultState = () => ({
    accessOptions: [],
    accessBandwidthOptions: [],
    electircalOpticalInterfaceOptions: [],
    serviceClassOptions: [],
    siteSurveyRequestedOptions: [],
    existingCircuitIDOptions: [],
    isCoordinatedServiceOptions: [],
    requiredLOACFAOptions: []
});
const initialState = defaultState();
const formModelName = "inventoryCircuitForm.accessInformation";

export const accessInformationFormInitialState = accessInformationFormModel;

export const accessInformationActions = {
    getCircuitAccessInformationDetails: (circuitID) => async (dispatch, state) => {
        var res = await httpGet('external/inventory/getCircuitAccessInformationItemDetails/' + circuitID);

        dispatch({
            type: getCircuitAccessInformationDetails,
            accessOptions: res.accessOptions,
            accessBandwidthOptions: res.accessBandwidthOptions,
            electircalOpticalInterfaceOptions: res.electircalOpticalInterfaceOptions,
            serviceClassOptions: res.serviceClassOptions,
            siteSurveyRequestedOptions: res.siteSurveyRequestedOptions,
            existingCircuitIDOptions: res.existingCircuitIDOptions,
            isCoordinatedServiceOptions: res.isCoordinatedServiceOptions,
            requiredLOACFAOptions: res.requiredLOACFAOptions,
        });

        if (res.data != null) {
            dispatch(actions.change(`${formModelName}.siteSurveyRequested`, res.data.SiteSurveyRequested ?? ""));
            dispatch(actions.change(`${formModelName}.accessBandwidth`, res.data.AccessBandwidth ?? ""));
            dispatch(actions.change(`${formModelName}.access`, res.data.Access ?? ""));
            dispatch(actions.change(`${formModelName}.existingCircuitID`, res.data.ExistingCircuitID ?? ""));
            dispatch(actions.change(`${formModelName}.isCoordinatedService`, res.data.CoordinatedService ?? ""));
            dispatch(actions.change(`${formModelName}.electricalOpticalInterface`, res.data.ElectricalOpticalInterface ?? ""));
            dispatch(actions.change(`${formModelName}.requiredLOACFA`, res.data.LOA_CFA_Required ?? ""));
            dispatch(actions.change(`${formModelName}.accessPortCIR`, res.data.Access_Port_CIR ?? ""));
            dispatch(actions.change(`${formModelName}.DLCI`, res.data.DLCI ?? ""));
            dispatch(actions.change(`${formModelName}.serviceClass`, res.data.ServiceClass ?? ""));
            dispatch(actions.change(`${formModelName}.uploadSpeed`, res.data.UploadSpeed ?? ""));
            dispatch(actions.change(`${formModelName}.downloadSpeed`, res.data.DownloadSpeed ?? ""));
            dispatch(actions.change(`${formModelName}.requestedIP`, res.data.RequestedIP ?? ""));
            dispatch(actions.change(`${formModelName}.handsOffType`, res.data.HandsOffType ?? ""));
        }
    },
    changeFormModel: (model, value) => (dispatch, state) => {
        dispatch(actions.change(model, value ?? ""));
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getCircuitAccessInformationDetails:
            return {
                ...state,
                accessOptions: action.accessOptions,
                accessBandwidthOptions: action.accessBandwidthOptions,
                electircalOpticalInterfaceOptions: action.electircalOpticalInterfaceOptions,
                serviceClassOptions: action.serviceClassOptions,
                siteSurveyRequestedOptions: action.siteSurveyRequestedOptions,
                existingCircuitIDOptions: action.existingCircuitIDOptions,
                isCoordinatedServiceOptions: action.isCoordinatedServiceOptions,
                requiredLOACFAOptions: action.requiredLOACFAOptions,
            };
        default:
            return state;
    }
}